module.exports = __webpack_public_path__ + "static/media/blue_arrow.081d8998.gif";